import { customBox as box, dropdown } from '../zIndex.js';
const dot = box + 10;
export { dot, box };
export const resizeBox = box + 2;
export const resizeDot = dot;
export const cropBox = box + 4;
export const cropImage = box + 4;
export const cropDot = dot + 2;
export const active = dropdown;
//# sourceMappingURL=zIndex.js.map